<script>
export default {
  props: {
    title: { type: String, default: '' },
    message: { type: String, default: '' },
  },
};
</script>

<template>
  <div class="empty-state py-16 px-1 ml-0 mr-0">
    <div class="flex justify-center mb-4">
      <slot name="icon" />
    </div>
    <h3
      v-if="title"
      class="text-slate-700 dark:text-n-gray-1 block text-center w-full text-base font-semibold"
    >
      {{ title }}
    </h3>
    <p
      v-if="message"
      class="block text-xs text-center text-slate-500 dark:text-slate-400 my-4 mx-auto w-[90%]"
    >
      {{ message }}
    </p>
    <slot />
  </div>
</template>